import { render, staticRenderFns } from "./CreateUpdatePage.vue?vue&type=template&id=e4bd22f6"
import script from "./CreateUpdatePage.vue?vue&type=script&lang=js"
export * from "./CreateUpdatePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports